import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const exportAeoPromptResults = unaryRpc({
  name: "exportAeoPromptResults",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ url: z.string() }),
});
